import React from 'react'
/*
  IMPORT COOKIE PROVIDER AND COOKIE RELATED ITEMS BELOW:
 */
import { instanceOf } from 'prop-types'
import { withCookies, Cookies } from 'react-cookie'
/*
  IMPORT COMPONENTS BELOW
 */
import Header from "./Header/Header"
import HelpButton from "./HelpButton/HelpButton"
import SignoutButton from "./SignoutButton/SignoutButton"
import SigninPage from "./SigninPage/SigninPage"
import MainPage from "./MainPage/MainPage"
import {Signout} from "../utils/APIRequests"
import HelpPopup from "./HelpPopup/HelpPopup"

class App extends React.Component{
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  }
  
  constructor(props){
    super(props)
    
    const { cookies } = props
    
    const dairyInfo = cookies.get('dairy') ? cookies.get('dairy').formattedDairyInfo : null
    
    this.state = {
      dairyInfo: dairyInfo,
      showHelp: false
    }
  }
  
  handleSignin(dairyInfo){
    const { cookies } = this.props
    
    if(!dairyInfo){
      return
    }
  
    let formattedSubdairies = []
    
    if(dairyInfo.subdairies[0]) {
      formattedSubdairies = dairyInfo.subdairies.map(subdairy => {
        let [dairyName, dairyId] = subdairy.split(',')
        return {
          dairy_id: parseInt(dairyId),
          dairy_name: dairyName
        }
      })
    }
    
    const formattedReports = dairyInfo.reports.map(report => {
      return {
        report_id: parseInt(report.report_id),
        report_dairy_id: parseInt(report.report_dairy_id),
        report_type: report.report_type,
        report_last_updated: report.report_last_updated
      }
    })
  
    let formattedDairyInfo = {...dairyInfo}
    
    formattedDairyInfo.subdairies = formattedSubdairies
    formattedDairyInfo.reports = formattedReports
    
    let [month, date, year] = new Date().toLocaleDateString("en-US").split("/")
    
    cookies.set(
      'dairy',
      {
        formattedDairyInfo
      },
      {
        path: '/',
        expires: new Date(parseInt(year), parseInt(month), parseInt(date), 23, 59, 59)
      }
    )
    
    this.setState({
      dairyInfo: formattedDairyInfo
    })
  }
  
  clearCookie(){
    const { cookies } = this.props
    
    cookies.remove("dairy")
    
    this.setState({
      dairyInfo: null
    })
  }
  
  signout(){
    const { cookies } = this.props
    
    cookies.remove('dairy')
  
    Signout(this.state.dairyInfo.dairy_login_username, this.state.dairyInfo.dairy_id, (data) => {
      this.setState({
        dairyInfo: null
      })
    })
  }
  
  showHelp(){
    this.setState((prevState) => {
      return {
        showHelp: !prevState.showHelp
      }
    })
  }
  
  render() {
    return (
      <div>
        {this.state.showHelp && <HelpPopup/>}
        <Header>
          <HelpButton clickFunc={this.showHelp.bind(this)}/>
          <SignoutButton logout={this.signout.bind(this)}/>
        </Header>
        {this.state.dairyInfo ?
          <MainPage
            dairyInfo={this.state.dairyInfo}
            clearCookies={this.clearCookie.bind(this)}
          /> :
          <SigninPage
            handleSignin={this.handleSignin.bind(this)}
          />}
      </div>
    )
  }
}

export default withCookies(App)